import type { BeforeRetryHook } from 'ky';
import ky from 'ky';
import type { LogoutArgs } from '../../types';
import { getRefreshUrl } from '../../utils';
import type { HookGetterArgs } from '../types';

interface KyError {
  response?: Response;
  [key: string]: unknown;
}

/**
 * Hook that refreshes the token and sets it in a cookie when a 401 error is encountered
 * This hook is called before retrying a request that failed with a 401 status code
 */
export const getRefreshTokenHook = (
  { baseURL }: HookGetterArgs,
  logout?: (args: LogoutArgs) => Promise<void>,
): BeforeRetryHook => {
  const refreshTokenHook: BeforeRetryHook = async (_options) => {
    const error = _options.error as unknown as KyError;
    // Only attempt to refresh token on 401 errors
    if (error.response?.status !== 401) {
      return;
    }

    // fetch a new token and set it in a cookie and refresh the cookie
    await ky(getRefreshUrl(baseURL), { method: 'GET' });
  };

  return refreshTokenHook;
};
